export const clearToastTimer = (toast) => {
    if (toast.timer === null) {
        return toast.expiresAt === null ? toast : { ...toast, expiresAt: null };
    }
    clearTimeout(toast.timer);
    return {
        ...toast,
        timer: null,
        expiresAt: null,
    };
};
//# sourceMappingURL=clearToastTimer.js.map